import { render, staticRenderFns } from "./BulkUploadPreview.vue?vue&type=template&id=585c044a&scoped=true"
import script from "./BulkUploadPreview.vue?vue&type=script&lang=js"
export * from "./BulkUploadPreview.vue?vue&type=script&lang=js"
import style0 from "./BulkUploadPreview.vue?vue&type=style&index=0&id=585c044a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c044a",
  null
  
)

export default component.exports